export var HotspotType;
(function (HotspotType) {
    HotspotType[HotspotType["Standard"] = 1] = "Standard";
    HotspotType[HotspotType["FixedHorizontal"] = 2] = "FixedHorizontal";
    HotspotType[HotspotType["FixedVertical"] = 3] = "FixedVertical";
    HotspotType[HotspotType["Back"] = 4] = "Back";
    HotspotType[HotspotType["Url"] = 5] = "Url";
    HotspotType[HotspotType["Anchor"] = 6] = "Anchor";
    HotspotType[HotspotType["Embed"] = 7] = "Embed";
    HotspotType[HotspotType["Video"] = 8] = "Video";
})(HotspotType || (HotspotType = {}));
export var HotspotLocation;
(function (HotspotLocation) {
    HotspotLocation[HotspotLocation["Normal"] = 0] = "Normal";
    HotspotLocation[HotspotLocation["Left"] = 1] = "Left";
    HotspotLocation[HotspotLocation["Right"] = 2] = "Right";
    HotspotLocation[HotspotLocation["Top"] = 3] = "Top";
    HotspotLocation[HotspotLocation["Bottom"] = 4] = "Bottom";
})(HotspotLocation || (HotspotLocation = {}));
